import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import CustomerForm from '../../components/CustomerForm';

const CustomerCreatePage = () => {
  const navigate = useNavigate();

  return (
    <Layout pageTitle="New Customer">
      <div className="max-w-4xl mx-auto p-6 bg-gray-50 min-h-screen">
        <h1 className="text-2xl font-bold mb-6">New Customer</h1>

        <div className="bg-white rounded-lg shadow-md p-6">
          <CustomerForm
            onSaved={() => navigate('/customer')}
            onCancel={() => navigate('/customer')}
          />
        </div>
      </div>
    </Layout>
  );
};

export default CustomerCreatePage;
